module.exports = __webpack_public_path__ + "img/fractal-silica.441b04a0.png";